/* eslint-disable max-len */
import { Role } from '../../../../generated/graphql';
import { TArgs, translate } from '../../../../utils';

export const roleToHintMap: Record<Role, TArgs> = {
    [Role.Admin]: translate('Has full acceess'),
    [Role.User]: translate('Can only update own profile details'),
    [Role.WarehouseGeneralManager]: translate('Has full access to warehouse'),
    [Role.WarehouseManager]: translate(`Has the same permissions as General Manager, but can't create/delete warehouse. Deletion of warehouse cards, categories is prohibited. This role can't start/end inventory counts`),
    [Role.WarehouseUser]: translate('Can only enter values on inventory count'),
};